import { render, staticRenderFns } from "./RiderPerformanceChart.vue?vue&type=template&id=3a05e9de&scoped=true&"
import script from "./RiderPerformanceChart.vue?vue&type=script&lang=js&"
export * from "./RiderPerformanceChart.vue?vue&type=script&lang=js&"
import style0 from "./RiderPerformanceChart.vue?vue&type=style&index=0&id=3a05e9de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a05e9de",
  null
  
)

export default component.exports